<script>
import metaInfo from '@/modules/mixins/metaInfo'
import Vue from 'vue'
import { Orders, TrackOrders } from '@/api'
import OrderBlock from '@/components/organism/block/OrderBlock'
import NoResult from '@/components/molecules/NoResult'
import Paginator from '@/components/molecules/Paginator'
import Spinner from '@/components/atoms/Spinner'
import pusher from '@/modules/mixins/pusher'
const orders = Vue.observable(new Orders())
const trackOrders = Vue.observable(new TrackOrders())
export default {
    name: 'Orders',
    components: { Paginator, NoResult, OrderBlock, Spinner },
    mixins: [pusher, metaInfo],
    data() {
        return {
            now: null,
        }
    },
    computed: {
        orders: () => orders,
        trackOrders: () => trackOrders,
        smDevice() {
            return this.$store.getters[`smDevice`]
        },
        pageTitle() {
            return this.$t('profile.pages.orders')
        },
    },
    mounted() {
        this.orders.fetchByRoute(this.$route, {
            page: this.$route.params.page,
            per_page: 10,
        })
        this.trackOrders.fetch({ limit: 100 })
    },
    created() {
        this.now = this.$moment()
        setInterval(() => {
            this.now = this.$moment()
        }, 60000)
        this.initializePusher()
    },
    methods: {
        async fetchOrders(page = 1) {
            if (page !== parseInt(this.$route.params.page)) {
                this.$router.push({ params: { page: page } })
                this.orders.fetchByRoute(this.$route, {
                    page: page,
                    per_page: 10,
                })
            }
        },
        async reloadOrders() {
            this.orders.fetchByRoute(this.$route, {
                page: parseInt(this.$route.params.page),
                per_page: 10,
            })
        },
    },
}
</script>

<template lang="pug">
.profile-orders.mb-11
    h2 {{ $t('profile.orders') }}
    .card.mb-6.relative(v-if="orders.total" :class="{'border-0 bg-transparent': smDevice}")    
        transition(name="fade")
            .position-absolute.w-100.h-100.top-0.left-0.border-radius-xs.z-1.bg-white.opacity-50(v-if="orders.loading" )
                spinner.position-sticky.top-50.d-block.mx-auto.mb-16.z-1(:size="30")
        order-block.mb-5(
            v-for="(order, index) in orders.items"
            @canceled="reloadOrders"
            :model="order"
            :pusher="pusher"
            :now="now"
            :tracking-list="trackOrders.items"
            :data-index="index"
            :key="`pastOrder-${order.identifier}`")
        .card-footer(:class="{'border-0 bg-transparent': smDevice}")
            paginator(:model="orders" @step="fetchOrders" programmatic)

    no-result(:loading="orders.loading" v-if="!orders.total") {{ $t('order.no_recent_orders') }}
</template>
